import { useMemo } from 'react';

import { selectAppConfig } from '@vlabs/shared/selectors/appSelectors';
import { useSelector } from 'react-redux';

import { useGetGeneralEvent, useGetStream } from '@vlabs/api/luna-api/client';

import { isValidGulfstreamConfig, sendGulfstreamAlarm } from './gulfstreamHandler';
import { isValidLaurent2Config, sendLaurent2Alarm } from './laurent2Handler';
import type { SendAlarmProps } from './types';

type TAlarmHandler = () => Promise<void>;

export function useAlarmHandler({ eventId }: SendAlarmProps): TAlarmHandler | null {
  const event = useGetGeneralEvent(eventId);
  const appConfig = useSelector(selectAppConfig);

  const laurent2Config = appConfig?.laurent2;
  const gulfstreamConfig = appConfig?.gulfstream;

  const eventType = event?.data?.event_type;
  const streamId = event?.data?.event?.stream_id;

  const { data: stream } = useGetStream(streamId ?? '', undefined, {
    query: {
      enabled: Boolean(streamId),
    },
  });
  const streamName = stream?.name ?? stream?.stream_id ?? 'Unknown Stream';

  return useMemo(() => {
    if (!eventType) return null;

    if (isValidLaurent2Config(laurent2Config, eventType)) {
      return async () => sendLaurent2Alarm({
        eventType,
        laurent2Config,
      });
    }

    if (isValidGulfstreamConfig(gulfstreamConfig)) {
      return async () => sendGulfstreamAlarm({
        eventType,
        streamName,
        gulfstreamConfig,
      });
    }

    return null;
  }, [eventType, streamName, laurent2Config, gulfstreamConfig]);
}
